import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import parallaxStyle from "assets/jss/material-kit-react/components/parallaxStyle.jsx"

import yourSharesMyFutureCta from "data/your-shares-my-future-cta.json";

// Sections for this page
import CTASection from "components/CTASection/CTASection.jsx";

import DaughtersWithMother from "components/Background/DaughtersWithMother.jsx";

const filter = parallaxStyle.filter;

const yourSharesMyFutureCTAStyle = {

};

class YourSharesMyFutureCTA extends React.Component {
  render() {
    const { classes, listIds, ...rest } = this.props;
    return (
      <DaughtersWithMother>
        <CTASection cta={yourSharesMyFutureCta} listIds={[26].concat(listIds)} filterOpacity="0.4"/>
      </DaughtersWithMother>
    );
  }
}

export default withStyles(yourSharesMyFutureCTAStyle)(YourSharesMyFutureCTA);
